import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import checkedImage from "../../../../../../../../assets/checkedbox.png";
import unCheckedImage from "../../../../../../../../assets/uncheckedBox.png";
import correct from "../../../../../../../../assets/correct.png";
import wrong from "../../../../../../../../assets/wrong.png";
import {
  getWeekAssessment,
  getWeekContentExcludingVideos,
  getWeekPreAssessment,
} from "../../../data/index.js";
import { useMutation, useQuery } from "@tanstack/react-query";
import userService from "../../../../../../../../services/api/user.js";
import { calculateResult } from "../../../utility.js";
import { adminData } from "../../../../../../../../redux/reducers/adminReducer.js";
import { useSelector } from "react-redux";
import adminService from "../../../../../../../../services/api/admin.js";
import Modal from "../../components/Modal.jsx";

function Week5({ enrollmentId, setWeekFiveData }) {
  const { pages } = getWeekContentExcludingVideos(5);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState("");

  const activity1 = pages.find((page) => page.id === 4);
  const activity2 = pages.find((page) => page.id === 6);
  const activity3 = pages.find((page) => page.id === 8);
  const activity4 = pages.find((page) => page.id === 10);
  const activity5 = pages.find((page) => page.id === 12);

  const [activityData, setActivityData] = useState([]);
  const [assessmentData, setAssessmentData] = useState([]);
  const [preAssessmentData, setPreAssessmentData] = useState([]);
  const [activityFeedbackId, setActivityFeedbackId] = useState(null);
  const { isAdmin, code } = useSelector(adminData);

  const { questions: assessments } = getWeekAssessment(5);
  const { questions: preAssessments } = getWeekPreAssessment(5);

  // toDo: Fetch User assessment and Activity Data
  const { data, isPending, status, isError } = useQuery({
    queryKey: ["dashboard/tot-feedback-5", enrollmentId, 5],
    queryFn: () =>
      isAdmin
        ? adminService.getUserCourseData(enrollmentId, 5, code)
        : userService.getUserCourseData(enrollmentId, 5),
    enabled: !!enrollmentId,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    keepPreviousData: false,
  });

  const mutation = useMutation({
    mutationFn: () =>
      adminService.submitAdminFeedback(
        activityData,
        enrollmentId,
        5,
        data?.activity?.user,
        code
      ),
    onSuccess: (data) => {
      setModalData("");
    },
    onError: (error) => {
      console.error("Registration error:", error);
      setModalData("");
    },
  });

  useEffect(() => {
    if (!data) return;

    const activities = Array.isArray(data.activity?.activities)
      ? data.activity.activities
      : [];
    setActivityData(activities);
    setAssessmentData(
      Array.isArray(data.assessment?.assessments)
        ? data.assessment.assessments
        : []
    );
    setPreAssessmentData(
      activities.find((p) => Number(p.page) === 2)?.answer || []
    );
    setWeekFiveData(true);

    return () => { };
  }, [data]);

  function getActivityAnswer(activityId) {
    return activityData?.find((activity) => activity.page === activityId)
      ?.answer;
  }

  const renderAnswerText = (answer) => {
    if (answer == null) return "";
    if (typeof answer === "string" || typeof answer === "number")
      return String(answer);
    if (Array.isArray(answer)) {
      return answer
        .map((item) => renderAnswerText(item))
        .filter(Boolean)
        .join(", ");
    }
    if (typeof answer === "object") {
      if ("value" in answer) return renderAnswerText(answer.value);
      if ("answer" in answer) return renderAnswerText(answer.answer);
      return "";
    }
    return "";
  };

  function getActivityFeedback(activityId, itemId, index) {
    if (!itemId) {
      return activityData?.find((activity) => activity.page === activityId)
        ?.feedback;
    } else {
      const answersList = activityData?.find(
        (activity) => activity.page === activityId
      )?.feedback;
      const answerObject = answersList?.find(
        (activity) => Number(activity.stepId) === Number(itemId)
      )?.value;

      // return answerObject ? answerObject[index] : null;
      return answerObject ? answerObject : null;
    }
  }

  const handleModalOpen = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setActivityFeedbackId(null);
    setShowModal(false);
  };

  function getOptionDetails(option) {
    const options = [
      {
        id: "A",
        text: "Self-awareness & Emotional Regulation",
      },
      {
        id: "B",
        text: "Resilience",
      },
      {
        id: "C",
        text: "Empathy",
      },
      {
        id: "D",
        text: "Collaboration & Social Awareness",
      },
    ];

    return options.find((item) => item.id === option) || null;
  }

  if (isPending) {
    return <div>Loading...</div>;
  }

  if (data?.status === "failed" || isError) {
    return <div>{data?.message || "Internal server error!"}</div>;
  }

  const score =
    calculateResult(assessments, assessmentData, assessments?.length) || 0;

  const submitFeedback = (value) => {
    if (!activityFeedbackId?.itemId) {
      const answerData = activityData.find(
        (item) => item.page === activityFeedbackId.activityId
      );
      answerData.feedback = value;
      handleModalClose();
      mutation.mutate();
    } else {
      const answerData = activityData?.find(
        (item) => item.page === activityFeedbackId.activityId
      );

      if (!answerData.feedback) {
        answerData.feedback = [];
      }

      const existingFeedbackIndex = answerData.feedback.findIndex(
        (item) => item.stepId === activityFeedbackId.itemId
      );

      if (existingFeedbackIndex >= 0) {
        answerData.feedback[existingFeedbackIndex].value = value;
      } else {
        answerData.feedback.push({
          stepId: activityFeedbackId.itemId,
          value: value,
        });
      }

      handleModalClose();
      setModalData("");
      mutation.mutate();
    }
  };

  return (
    <>
      {/* PreAssesment 1 */}
      <p className="bg-blue py-1 px-1 py-md-3 px-md-2 text-white d-inline-block rounded-5 fs-md-4">
        Pre-Assessment
      </p>
      <hr />
      {preAssessments.map(({ id, question, options, correctOption }, i) => {
        // todo:  fetch preassesment data from backend and switch
        const selectedAnswer = Array.isArray(preAssessmentData)
          ? preAssessmentData.find((answer) => answer.id === id)?.value
          : undefined;
        return (
          <>
            <div className="d-flex gap-3" key={i}>
              <p
                className="text-blue fs-md-1 text-nowrap week-2-question-text fw-bold"
                style={{ fontSize: 1 + "em" }}
              >
                Questions {i + 1}:
              </p>
              <p
                className="text-blue fs-md-4 week-2-question-text"
                style={{ fontSize: 1 + "em" }}
              >
                {question}
              </p>
            </div>
            {options.map((option, index) => {
              const optionKey = Object.keys(option)[0];
              const optionText = option[optionKey];
              const isCorrectOption = correctOption === optionText;
              const isAnswer = selectedAnswer === optionText;
              // console.log(assessmentData,"AssessmentData")

              return (
                <div
                  key={index}
                  className="d-flex gap-md-2 p-0 p-md-1 mb-3 justify-content-between"
                >
                  <div className="d-flex gap-md-2 p-1">
                    <img
                      src={isAnswer ? checkedImage : unCheckedImage}
                      alt={`Option ${optionKey}`}
                      style={{ width: 20, height: 20 }}
                    />
                    <div
                      className="week-2-question-text text-gray"
                      style={{ fontSize: 1 + "em" }}
                    >{`${optionText}. ${option.text}`}</div>
                  </div>
                  {isCorrectOption ? (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={correct}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />{" "}
                      Correct
                    </p>
                  ) : (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={wrong}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                      Wrong
                    </p>
                  )}
                </div>
              );
            })}
          </>
        );
      })}
      <hr />

      {/* Activity 1 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 1
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p className="text-blue fs-md-1 week-2-question-text fw-bold" style={{ fontSize: 1 + "em" }}>
          Question:
        </p>
        <p className="text-blue fs-md-4 week-2-question-text" style={{ fontSize: 1 + "em" }}>
          {activity1.question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p className="text-gray fs-md-1 week-2-question-text" style={{ fontSize: 1 + "em" }}>
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">{renderAnswerText(getActivityAnswer(activity1.id))}</p>
        {isAdmin && !getActivityFeedback(activity1.id) && (
          <Icon onClick={() => { setActivityFeedbackId({ activityId: activity1.id }); handleModalOpen(); }} style={{ color: "#D6D6D6" }} width={35} icon="tabler:message-2" />
        )}
      </div>
      {getActivityFeedback(activity1.id) && (
        <div className="d-flex gap-3">
          <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">Feedback</p>
          <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">{getActivityFeedback(activity1.id)}</p>
          {isAdmin && <Icon onClick={() => { setModalData(getActivityFeedback(activity1.id)); setActivityFeedbackId({ activityId: activity1.id }); handleModalOpen(); }} style={{ color: "#275DAD" }} width={35} icon="lucide:edit" />}
        </div>
      )}
      <hr />

      {/* Activity 2 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 2
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity2.steps[1].question[0].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity2.id);
            if (!Array.isArray(answers) || !answers[0] || !answers[0].subject)
              return "";
            return answers[0].subject;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity2.id, 1) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity2.id, itemId: 1 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity2.id, 1) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity2.id, 1)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity2.id, 1));
                  setActivityFeedbackId({ activityId: activity2.id, itemId: 1 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity2.steps[1].question[1].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity2.id);
            if (!Array.isArray(answers) || !answers[0] || !answers[0].skill)
              return "";
            return answers[0].skill;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity2.id, 2) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity2.id, itemId: 2 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity2.id, 2) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity2.id, 2)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity2.id, 2));
                  setActivityFeedbackId({ activityId: activity2.id, itemId: 2 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Activity 3 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 3
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.questions[0].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity3.id);
            if (!Array.isArray(answers) || !answers[0] || !answers[0].game)
              return "";
            return answers[0].game;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity3.id, 1) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id, itemId: 1 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity3.id, 1) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id, 1)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id, 1));
                  setActivityFeedbackId({ activityId: activity3.id, itemId: 1 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.questions[1].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity3.id);
            if (
              !Array.isArray(answers) ||
              !answers[0] ||
              !answers[0].instructions
            )
              return "";
            return answers[0].instructions;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity3.id, 2) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id, itemId: 2 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity3.id, 2) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id, 2)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id, 2));
                  setActivityFeedbackId({ activityId: activity3.id, itemId: 2 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 3:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.questions[2].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity3.id);
            if (
              !Array.isArray(answers) ||
              !answers[0] ||
              !answers[0].connection
            )
              return "";
            return answers[0].connection;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity3.id, 3) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id, itemId: 3 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity3.id, 3) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id, 3)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id, 3));
                  setActivityFeedbackId({ activityId: activity3.id, itemId: 3 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Activity 4 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 4
      </p>
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity4.steps[0].instructions.map((text) => (
          <>
            <span className="text-gray">{text}</span>
            <br />
          </>
        ))}
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity4.steps[1].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity4.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity4.steps[1].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity4.id, 2) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity4.id, itemId: 2 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity4.id, 2) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity4.id, 2)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity4.id, 2));
                  setActivityFeedbackId({ activityId: activity4.id, itemId: 2 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity4.steps[2].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity4.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity4.steps[2].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity4.id, 3) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity4.id, itemId: 3 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity4.id, 3) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity4.id, 3)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity4.id, 3));
                  setActivityFeedbackId({ activityId: activity4.id, itemId: 3 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 3:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity4.steps[3].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity4.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity4.steps[3].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity4.id, 4) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity4.id, itemId: 4 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity4.id, 4) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity4.id, 4)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity4.id, 4));
                  setActivityFeedbackId({ activityId: activity4.id, itemId: 4 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 4:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity4.steps[4].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity4.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity4.steps[4].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity4.id, 5) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity4.id, itemId: 5 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity4.id, 5) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity4.id, 5)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity4.id, 5));
                  setActivityFeedbackId({ activityId: activity4.id, itemId: 5 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }

      <hr />

      {/* Activity 5 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 5
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity5.question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {renderAnswerText(getActivityAnswer(activity5.id))}
        </p>
        {isAdmin &&
          !activityData?.find((activity) => activity.page === activity5.id)
            ?.feedback && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity5.id });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        activityData?.find((activity) => activity.page === activity5.id)
          ?.feedback && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity5.id)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity5.id));
                  setActivityFeedbackId({ activityId: activity5.id });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      {/* Assesment 1 */}
      <p className="bg-blue py-1 px-1 py-md-3 px-md-2 text-white d-inline-block rounded-5 fs-md-4">
        Post-Assessment
      </p>
      <hr />
      {assessments.map(({ id, question, options, correctOption }, i) => {
        const selectedAnswer = assessmentData?.find(
          (answer) => answer.id === id
        )?.value;
        return (
          <>
            <div className="d-flex gap-3" key={i}>
              <p
                className="text-blue fs-md-1 text-nowrap week-2-question-text fw-bold"
                style={{ fontSize: 1 + "em" }}
              >
                Questions {i + 1}:
              </p>
              <p
                className="text-blue fs-md-4 week-2-question-text"
                style={{ fontSize: 1 + "em" }}
              >
                {question}
              </p>
            </div>
            {options.map((option, index) => {
              const optionKey = Object.keys(option)[0];
              const optionText = option[optionKey];
              const isCorrectOption = correctOption === optionText;
              const isAnswer = selectedAnswer === optionText;
              // console.log(assessmentData,"AssessmentData")

              return (
                <div
                  key={index}
                  className="d-flex gap-md-2 p-0 p-md-1 mb-3 justify-content-between"
                >
                  <div className="d-flex gap-md-2 p-1">
                    <img
                      src={isAnswer ? checkedImage : unCheckedImage}
                      alt={`Option ${optionKey}`}
                      style={{ width: 20, height: 20 }}
                    />
                    <div
                      className="week-2-question-text text-gray"
                      style={{ fontSize: 1 + "em" }}
                    >{`${optionText}. ${option.text}`}</div>
                  </div>
                  {isCorrectOption ? (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={correct}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />{" "}
                      Correct
                    </p>
                  ) : (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={wrong}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                      Wrong
                    </p>
                  )}
                </div>
              );
            })}
          </>
        );
      })}
      <hr />

      {/* Weekly Report */}

      <div className="bg-button p-3 p-md-5 rounded-4">
        <h2 className="text-white fs-md-1">Weekly Report</h2>
        <div className="d-flex flex-column flex-md-row gap-4">
          <h2 className="text-gray fs-md-1 ratio-1x1 bg-aqua rounded-4 p-3 p-md-5 d-flex justify-content-center border border-6 border-blue">
            {score}%
          </h2>
          <p className="text-white">
            {score < 40
              ? "You’ve taken an important first step in exploring Social and Emotional Learning and Positive Psychology. You’ve started to understand the value of emotional awareness, relationship skills, and teacher wellbeing. However, it seems you may still be building a full grasp of how SEL connects to classroom practice. Revisit the lessons and take time to reflect on how self-awareness and self-management can shape your approach to teaching. Don’t hesitate to ask questions or discuss ideas with your peers; collaboration is one of the best ways to deepen understanding. Every teacher starts somewhere, and your willingness to learn is already a sign of growth"
              : score < 60
                ? "Good effort! You’re beginning to grasp key SEL and Positive Psychology principles such as self-awareness, empathy, and the importance of wellbeing in the classroom. You have a fair understanding of how emotional intelligence supports both teachers and students, but there’s room to strengthen your practical application. Try focusing on mindfulness and emotional regulation strategies in your daily teaching routine. Reflect after each class, ‘How did your emotional state affect your students' responses?’ The more intentional you are, the more confident and balanced you’ll become in integrating SEL principles effectively."
                : score < 80
                  ? "Well done! You’ve shown a strong understanding of SEL and Positive Psychology concepts and are starting to connect them meaningfully to your classroom practice. You recognize how empathy, relationship-building, and emotional regulation influence learning outcomes. To keep improving, aim to apply SEL more consistently, model calm responses to challenges, and build structured moments for reflection or gratitude in your lessons. You’re well on your way to creating a classroom culture rooted in care, connection, and emotional growth."
                  : score < 95
                    ? "Excellent work! You’ve demonstrated a clear understanding of SEL and Positive Psychology competencies and how its principles can transform both teaching and learning. You’ve likely developed effective strategies for fostering empathy, self-regulation, and resilience in your students, and you understand the importance of teacher wellbeing in sustaining those practices. Keep refining your skills by mentoring peers or sharing SEL practices in team meetings. Continue to model emotional intelligence in every interaction, and you will build the kind of classroom where students feel safe, motivated, and valued."
                    : score <= 100
                      ? "Outstanding achievement! You’ve shown exceptional mastery of Social and Emotional Learning. You not only understand the theory but also demonstrate how to live it out in your teaching, balancing self-awareness, empathy, and resilience with skill. Your approach likely fosters deep trust, engagement, and growth in your students. Continue to inspire others by leading discussions on SEL implementation and supporting colleagues who are just beginning their journey. Your dedication to nurturing emotional wellbeing in education sets a powerful example. Keep shining, the ripple effect of your work will last far beyond the classroom."
                      : ""}
          </p>
        </div>
        <Modal
          isOpen={showModal}
          closeModal={handleModalClose}
          data={modalData}
          handleSubmit={submitFeedback}
        />
      </div>
    </>
  );
}

export default Week5;
